 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React, {Fragment, useMemo} from 'react'
import {useFragment} from 'react-relay'
import {PALETTE} from '~/styles/paletteV3'
import {Breakpoint} from '~/types/constEnums'
import makeMinWidthMediaQuery from '~/utils/makeMinWidthMediaQuery'




import LeftDashNavItem from '../Dashboard/LeftDashNavItem'

const DashNavListStyles = styled('div')({
  paddingRight: 8,
  width: '100%'
})

const OrgName = styled('div')({
  paddingTop: 8,
  paddingLeft: 8,
  fontWeight: 600,
  fontSize: 12,
  lineHeight: '24px',
  color: PALETTE.SLATE_500,
  [makeMinWidthMediaQuery(Breakpoint.SIDEBAR_LEFT)]: {
    paddingLeft: 16
  }
})

const EmptyTeams = styled('div')({
  fontSize: 16,
  fontStyle: 'italic',
  padding: 16,
  textAlign: 'center'
})

const DashHR = styled('div')({
  borderBottom: `1px solid ${PALETTE.SLATE_300}`,
  width: 'calc(100% + 8px)'
})

const StyledLeftDashNavItem = styled(LeftDashNavItem)(
  ({isViewerOnTeam}) => ({
    color: isViewerOnTeam ? PALETTE.SLATE_700 : PALETTE.SLATE_600
  })
)









const DashNavList = (props) => {
  const {className, onClick, organizationsRef} = props
  const organizations = useFragment(
    graphql`
      fragment DashNavList_organization on Organization @relay(plural: true) {
        allTeams {
          ...DashNavListTeam @relay(mask: false)
        }
        viewerTeams {
          ...DashNavListTeam @relay(mask: false)
        }
        featureFlags {
          publicTeams
        }
      }
    `,
    organizationsRef
  )
  const teams = _optionalChain([organizations, 'optionalAccess', _ => _.flatMap, 'call', _2 => _2((org) => {
    // if the user is a billing leader, allTeams will return all teams even if they don't have the publicTeams flag
    const hasPublicTeamsFlag = org.featureFlags.publicTeams
    return hasPublicTeamsFlag ? org.allTeams : org.viewerTeams
  })])

  const teamsByOrgKey = useMemo(() => {
    if (!teams) return null
    const teamsByOrgId = {} 
    teams.forEach((team) => {
      const {organization} = team
      const {id: orgId, name: orgName} = organization
      const key = `${orgName}:${orgId}`
      teamsByOrgId[key] = teamsByOrgId[key] || []
      teamsByOrgId[key].push(team)
    })
    return Object.entries(teamsByOrgId).sort((a, b) =>
      a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1
    )
  }, [teams])
  if (!teams || !teamsByOrgKey) return null

  if (teams.length === 0) {
    return React.createElement(EmptyTeams, null, "It appears you are not a member of any team!"         )
  }

  const isSingleOrg = teamsByOrgKey.length === 1

  const getIcon = (team) => (team.organization.lockedAt || !team.isPaid ? 'warning' : 'group')

  return (
    React.createElement(DashNavListStyles, null
      , isSingleOrg
        ? teams.map((team) => (
            React.createElement(StyledLeftDashNavItem, {
              className: className,
              onClick: onClick,
              isViewerOnTeam: team.isViewerOnTeam,
              key: team.id,
              icon: getIcon(team),
              href: team.isViewerOnTeam ? `/team/${team.id}` : `/team/${team.id}/requestToJoin`,
              label: team.name,}
            )
          ))
        : teamsByOrgKey.map((entry, idx) => {
            const [key, teams] = entry
            const name = key.slice(0, key.lastIndexOf(':'))
            return (
              React.createElement(Fragment, { key: key,}
                , React.createElement(OrgName, null, name)
                , teams.map((team) => (
                  React.createElement(StyledLeftDashNavItem, {
                    className: className,
                    isViewerOnTeam: team.isViewerOnTeam,
                    onClick: onClick,
                    key: team.id,
                    icon: getIcon(team),
                    href: 
                      team.isViewerOnTeam ? `/team/${team.id}` : `/team/${team.id}/requestToJoin`
                    ,
                    label: team.name,}
                  )
                ))
                , idx !== teamsByOrgKey.length - 1 && React.createElement(DashHR, null )
              )
            )
          })
    )
  )
}

graphql`
  fragment DashNavListTeam on Team {
    id
    isPaid
    name
    isViewerOnTeam
    organization {
      id
      name
      lockedAt
    }
  }
`
export default DashNavList
